import React from "react";
import { Card, IOSSwitch } from "./styles";

interface Participation {
  ativo: boolean;
  reu: boolean;
  citado: boolean;
}

interface ScenarioCardProps {
  id: number;
  label: string;
  isEnabled: boolean;
  onToggleEnabled: (id: number, scenarioId: number) => void;
  participation: Participation;
  onToggleParticipation: (
    id: number,
    field: keyof Participation,
    scenarioId: number
  ) => void;
  scenarioId: number;
  readOnly?: boolean;
}

export const ScenarioCard: React.FC<ScenarioCardProps> = ({
  id,
  label,
  isEnabled,
  onToggleEnabled,
  participation,
  onToggleParticipation,
  scenarioId,
  readOnly = false,
}) => {

  return (
    <Card disabled={!isEnabled || readOnly}>
      <div className="sphere-label">
        <span>{label}</span>
        <IOSSwitch
          checked={isEnabled}
          onChange={() => !readOnly && onToggleEnabled(id, scenarioId)}
          disabled={readOnly}
        />
      </div>
      <div className="info-container">
        <div className="info-item">
          <span>Envolvimento no processo:</span>
          <div className="switch-container">
            <div className="switch-item">
              <span>Ativo</span>
              <IOSSwitch
                checked={participation.ativo}
                onChange={() =>
                  !readOnly && onToggleParticipation(id, "ativo", scenarioId)
                }
                disabled={!isEnabled || readOnly}
              />
            </div>
            <div className="switch-item">
              <span>Réu</span>
              <IOSSwitch
                checked={participation.reu}
                onChange={() =>
                  !readOnly && onToggleParticipation(id, "reu", scenarioId)
                }
                disabled={!isEnabled || readOnly}
              />
            </div>
            <div className="switch-item">
              <span>Citado</span>
              <IOSSwitch
                checked={participation.citado}
                onChange={() =>
                  !readOnly && onToggleParticipation(id, "citado", scenarioId)
                }
                disabled={!isEnabled || readOnly}
              />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
